[
  {
    "url": "/_next/static/u1XXicN7e7MYcWe8BRoQ4/_ssgManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/u1XXicN7e7MYcWe8BRoQ4/_clientMiddlewareManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/u1XXicN7e7MYcWe8BRoQ4/_buildManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/media/video.3g7l0xxqg6xqd.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/unicorn.1vqyovtb30ost.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/tutorial-light.1_0mrz_l0l0qh.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/tutorial-dark.285oi1cqd264k.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/touch-light.2f6n3fekanliv.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/touch-light.0966i3m9jmy_l.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/share-menu.0k4cq6bstgscq.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/search.0o170vpyc0nbj.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/question-mark-det.2n7ugond45wdl.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/publisher-logo-60px.0qxdnhbu19qbx.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/not-found.1z6f-r6rpdbhh.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/not-found.0twxsexrrm5rc.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/monochrome-icons-sprite.0-phh-koi5ysq.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/mainzel.1cpm0ovv0f6so.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/homescreen-button.3-zs1qsm8at8f.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/ground.1o1thgxw2h2rc.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/favicon.1b2t3ozuo6pew.ico",
    "revision": null
  },
  {
    "url": "/_next/static/media/emo-404.2cswnm_t5__9j.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/corrected-topic.43icaz9ck_i4x.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/corrected-topic.3aqz81hbzfgwq.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/bookmark.2nw5xksmtunu2.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/apple-touch-icon-180x180.0cvnvlsyzp4ow.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/app-icon.3jfqc-0kpc6m2.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/app-icon-512x512.0qrb3e8b839gt.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/app-icon-192x192.103s66a22qum4.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/app-icon-144x144.0ltgoql47ne-j.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/all-done-light.078a1cfc-h54_.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/all-done-dark.269nmc0g6m20d.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/9_16.25vvw8bz4h04d.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/9_16.05_s3avor828v.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/8_9.3-th-ajdgc7_r.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/8_9.0zpi7_qukd76i.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/3_1.1kzbpwa4a4apb.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/3_1.171khf48zmt79.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/1_1.33rzgp7-6twig.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/1_1.2vfp-4_mrlxg2.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/16_9.1541-i-x3_s1-.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/16_9.058nrfld9rob4.svg",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-071z0096te3w9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/41mnrn_g7ytgi.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3zyjovp26q_k8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3z63_ndswg72o.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3vg1_15mvr09q.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3tosy6c9gvrs7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3sjm8x0txzrtl.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3qn81nnb9-jfa.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3kmbjogyjgrwz.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3i2iwpkmym95e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3gd5m2wkg0z1c.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3f4yxlrr3gkaz.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/39qtrleoi15yz.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/380pqzd7i_js1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/35i_69rfl80fr.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/33tcrg47hwhfm.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2wsljc0ld3ns6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2w4a58goixe5q.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2vc_dbiua_xuf.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2ue2phasthlvp.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2py4uwga67ezr.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2o_i3tujousfi.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2iv2ieihnok-w.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2hw9ac7bx0dp0.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2euv438ciz8ns.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2c06rh72zoyja.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/27x2b1vymp__w.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/27iq7oam-zh5s.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/24dwmmi0sdyot.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/20c9hsh31p809.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/208buxfgrongb.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1xyv3jatdy177.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1xbk7kqy3r0sc.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1uf5a_6zlqibl.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1s-8qooc2fw86.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1pg29iesvv-fk.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1lyy6e3b2ro8w.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1hyhn4zlayj7i.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1erij5ck9awu2.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1bmcr9wcjii6f.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/16s36hv6oucrb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1590vew464ap1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/13ogwiyqkt27f.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/11cp8676qzrc3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1-817gq7y4ag_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0z2gf-_c2fa15.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0xhys8-h6em-_.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0x-o-wy31593z.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0wh4fbbdb3zt9.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0vjj7oo1kdqr9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0tnet8sj6bdw9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0rqu2dokx-att.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0pe0di_hl63x-.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0n0ajrlssvc-s.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0kynwtoqacxu4.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0jri4s5whl3ez.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0hr_gqxa_cj6y.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0fumf0ry_o18v.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0cz1d0mv5g_q7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0c4elco88-5j8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/08k044q2ml213.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/061x6f2rt4kyp.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/04n48g_arqwv0.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/02u4pwub9flha.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/00awmefvb4kxs.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/004x-w4x2lwx5.js",
    "revision": null
  },
  {
    "url": "/nachrichten/sw.js",
    "revision": "827c5d15f8f6816dc0601201afcfd406"
  },
  {
    "revision": "1511eaa9-58ed-452e-aefa-2df3c415045e",
    "url": "/~offline"
  }
]